import React from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import CreatePosition from './createPositions'
import { checkPriority, checkWorkLocation, getMilliSec, makeSideBarActive } from '../../utils/EllowUtils';
import * as CONSTANTS from '../../utils/CONSTANTS'
import { useNavigate } from 'react-router-dom';
import { useState , useEffect } from 'react';
import { getAPI,  postAPI } from "../../api/api";
import classnames from "classnames"; 
import { REACT_APP_COMMON, REACT_APP_CUSTOMER, REACT_APP_JOB } from '../../utils/common';
import NotificationAlert from "../../components/notification";
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';
import { updateCrowdSourcingStatus } from "./services"


function CreatePositions() {

  const navigate = useNavigate()

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1)
  const BreadcrumsValues = ['Positions', 'Create Positions']
  const loginId = localStorage.getItem('loginId')

  const [postPosition, setPostPosition] = useState<[{companyName: string ; companyId: string}]>([{companyName: '' , companyId: ''}])
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [skillList, setSkillList] = useState<any>()
  const [jobRoleList, setJobRoleList] = useState<any>()
  useEffect(() => {

    getAPI( REACT_APP_CUSTOMER + "/customer-list").then(
      (response: any) => {
        if (response && response.status === 1) {
          setPostPosition(response.data);
        }
      }
    );
    getAPI( REACT_APP_COMMON + '/skills').then((resp: any) => {
      if (resp && resp.status === 1) {
        setSkillList(resp.data);
      }
    })

    getAPI( REACT_APP_COMMON + '/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })
  }, []);

  useEffect (() => {
    viewedpageMixpanel();
  })


  const submitCrowdSourcingStatus = (jobId: string , companyDetails: string , toggleButton: any) => {

    let data = {
      "jobId": jobId,
      "status": toggleButton,
      "companyDetails": companyDetails,
      "userLoginId": loginId
    }
    updateCrowdSourcingStatus(data).then((response: any) => {

    })
  }

  const submitValues = (data: any, companyDetails: any , toggleButton: any) => {
    
    postAPI( REACT_APP_JOB + '/position' , data).then((response) => {
      if (response && response.status === 1) {
          if(companyDetails !== ' '){
             submitCrowdSourcingStatus(response && response.data[0] && response.data[0].jobId , companyDetails, toggleButton)
          }
          //const skills: {name: string, experience: string, expertise: number}[] = data.jobMetadata && data.jobMetadata && data.jobMetadata.coreSkills && data.jobMetadata.coreSkills.map((item: {skill: {skillId: number, skillName: string}}) => { return (item && item.skill && item.skill.skillName) })
          const skills = data && data.jobMetadata && data.jobMetadata.coreSkills && data.jobMetadata.coreSkills.map((item: any) => item.skillName)
          const otherSkills = data && data.jobMetadata && data.jobMetadata.otherSkills && data.jobMetadata.otherSkills.map((item: any) => item.skillName)
          let locations = data.jobMetadata.locationPreference.location && data.jobMetadata.locationPreference.location.map((item: any) => item.name)

          mixpanelData(data.action === 'publish' ? `TG - Positions Created` : `TG - Position ${data.action}ed` , {
          'source': `Recruiter ${data.action}ed a position`,
          "distinct_id": localStorage.getItem('Email'),
          "Recruiter Email" : localStorage.getItem('Email'),
          'position_behalf_of': data.jobMetadata && data.jobMetadata.postPosition && data.jobMetadata.postPosition.companyName,
          'title': data.jobMetadata && data.jobMetadata.title,
          'resource_count': data.jobMetadata && data.jobMetadata.resourceCount,
          'experience': data.jobMetadata && data.jobMetadata.experienceRange && (data.jobMetadata.experienceRange.min + ' - ' + data.jobMetadata.experienceRange.max),
          'jobRole': data.jobMetadata && data.jobMetadata.jobRole && data.jobMetadata.jobRole.name,
          'type_0f_job': data.jobMetadata && data.jobMetadata.jobType,
          'priority': data.jobMetadata && data.jobMetadata.priority && checkPriority(data.jobMetadata.priority),
          'core_skills': skills && skills,
          'Other Skills': otherSkills && otherSkills,
          'contract_period': data.jobMetadata && data.jobMetadata.contractDuration,
          'contractStartDate': data.jobMetadata && data.jobMetadata.contractStartDate && new Date(data.jobMetadata.contractStartDate).toDateString().slice(3),
          'billingType': data.jobMetadata && data.jobMetadata.billingType,
          'currencyType': data.jobMetadata && data.jobMetadata.currencyType,
          'maximumBudget': data.jobMetadata && data.jobMetadata.maximumBudget,
          'minimumBudget': data.jobMetadata && data.jobMetadata.minimumBudget,  
          'jobId': response && response.data[0] && response.data[0].jobId,
          'allocatedTo': data.action !== 'update' && localStorage.getItem('Name'),
          'Work Location': data && data.jobMetadata && data.jobMetadata.locationPreference && (data.jobMetadata.locationPreference.remoteType || data.jobMetadata.locationPreference.remoteType === 0) && checkWorkLocation(data.jobMetadata.locationPreference.remoteType, data.jobMetadata.locationPreference.location),
        })

        mixpanelData(data.action === 'publish' ? `New TG - Positions Created` : `New TG - Position ${data.action}ed` , {
          'Source': `Recruiter ${data.action}ed a position`,
          'Position behalf of': data.jobMetadata && data.jobMetadata.postPosition && data.jobMetadata.postPosition.companyName,
          'Position name': data.jobMetadata && data.jobMetadata.title,
          'Resource count': data.jobMetadata && data.jobMetadata.resourceCount,
          'Job role': data.jobMetadata && data.jobMetadata.jobRole && data.jobMetadata.jobRole.name,
          'Job type': data.jobMetadata && data.jobMetadata.jobType,
          'Experience': data.jobMetadata && data.jobMetadata.experienceRange && `${data.jobMetadata.experienceRange.min} - ${data.jobMetadata.experienceRange.max} Years`,
          'Priority': data.jobMetadata && data.jobMetadata.priority && checkPriority(data.jobMetadata.priority),
          'Core skills': skills && skills,
          'Other skills': otherSkills && otherSkills,
          'Work location': data && data.jobMetadata && data.jobMetadata.locationPreference && (data.jobMetadata.locationPreference.remoteType || data.jobMetadata.locationPreference.remoteType === 0) && checkWorkLocation(data.jobMetadata.locationPreference.remoteType, data.jobMetadata.locationPreference.location),
          'Work location array': locations,
          'Active positions': parseInt(data.jobMetadata.resourceCount) - (parseInt(data.jobMetadata.closedCount) + parseInt(data.jobMetadata.lossCount)),
          'Crowdsourcing enabled': toggleButton ? toggleButton : false,
          'Contract period': data.jobMetadata && data.jobMetadata.contractDuration,
          'Contract start date': data.jobMetadata && data.jobMetadata.contractStartDate && new Date(data.jobMetadata.contractStartDate).toDateString().slice(3),
          'Max-Budget': data.jobMetadata && `${data.jobMetadata.maximumBudget} ${data.jobMetadata && data.jobMetadata.currencyType} / ${data.jobMetadata && data.jobMetadata.billingType}`,
          'Min-Budget': data.jobMetadata && `${data.jobMetadata.minimumBudget} ${data.jobMetadata && data.jobMetadata.currencyType} / ${data.jobMetadata && data.jobMetadata.billingType}`,  
          "distinct_id": localStorage.getItem('Email'),
          "Recruiter email" : localStorage.getItem('Email'),
          'Allocated to': response.data[0].allocatedTo ? response.data[0].allocatedTo : 'NA',
          'Notice period': data.jobMetadata && data.jobMetadata.jobType === 'Full time' ? `${data.jobMetadata && data.jobMetadata.noticePeriod} Days` : 'NA',
          'JobId': response && response.data[0] && response.data[0].jobId,
        })
        displayNotification(data.action)
        if(data.action === 'publish'){
          mixpanelData('New TG - Position Allocated to Updated', {
            'source': "Recruiter changed the allocation while position is created",
            'distinct_id': localStorage.getItem('Email'),
            'Recruiter email': localStorage.getItem('Email'),
            'Position name': data.jobMetadata && data.jobMetadata.title,
            "Jobrole": data.jobMetadata && data.jobMetadata.jobRole && data.jobMetadata.jobRole.name,
            "JobId": response && response.data[0] && response.data[0].jobId,
            'Company name': data.jobMetadata && data.jobMetadata.postPosition && data.jobMetadata.postPosition.companyName,
            'Allocated To': response.data[0].allocatedTo ? response.data[0].allocatedTo : '',
            "Active position" : data.jobMetadata && data.jobMetadata.resourceCount,
            'Type of job': data.jobMetadata && data.jobMetadata.jobType
          }) 
          if(toggleButton){
            mixpanelData('New TG - Position Crowd sourcing updated', {
              'source': "Crowd sourcing is enabled while creating a position",
              'distinct_id': localStorage.getItem('Email'),
              'Recruiter email': localStorage.getItem('Email'),
              'Position name': data.jobMetadata && data.jobMetadata.title,
              "Job role": data.jobMetadata && data.jobMetadata.jobRole && data.jobMetadata.jobRole.name,
              "JobId": response && response.data[0] && response.data[0].jobId,
              'Company name': data.jobMetadata && data.jobMetadata.postPosition && data.jobMetadata.postPosition.companyName,
              'Allocated to': response.data[0].allocatedTo ? response.data[0].allocatedTo : '',
              'Crowdsourcing enabled': toggleButton,
              "Active position" : data.jobMetadata && data.jobMetadata.resourceCount
            })
          } 
        }
      }
    })
  }


  const publish = (value: any , counts: any , toggleButton: any) => { 
 
    let finalValue = {
      userLoginId: loginId,
      submittedBy: "RECRUITER",
      jobId: value.jobId !== '' ? value.jobId : "" ,
      action: value.key === 'update' ? value.key : "publish",
      jobMetadata: {
        postPosition:  value.data.postPosition,
        title:  value.data.title,
        resourceCount: value.data.resources ? value.data.resources : 0,
        jobRole: value.data.jobRole,
        locationPreference: value.locationPreference,
        jobType: value.data.jobType ? value.data.jobType : "",
        experienceRange : value.experienceRange ? value.experienceRange : {"min" : 0 , "max": 12},
        priority: value.data.priority ? value.data.priority.id : 2,
        coreSkills: value.data.coreSkills,
        otherSkills: value.data.otherSkills ? value.data.otherSkills : [],
        supportingDocument: value.supportingDocument !== ' '? value.supportingDocument : "",   
        contractDuration: value.data.contractDuration ? value.data.contractDuration : "",
        billingType: value.data.billingType ? value.data.billingType : "",
        currencyType: value.data.currencyType ? value.data.currencyType : "",
        minimumBudget: value.data.minimumBudget ? parseInt(value.data.minimumBudget) : "",
        maximumBudget: value.data.maximumBudget ? parseInt(value.data.maximumBudget) : "",
        jobDescription: value.data.jobDescription ?  value.data.jobDescription : "",
        contractStartDate: value.data.startDate ? value.data.startDate : 0,
        closedCount: counts.closedCount,
        lossCount: counts.lossCount,
        noticePeriod: value.data.noticePeriod ? value.data.noticePeriod : 0
      },
    } 
    const companyDetails = value.data.companyDetails ? value.data.companyDetails : ' '
    submitValues(finalValue,companyDetails,toggleButton)
  }

  
  const save = (value: any , counts: any , toggleButton: any) => {
  
    let finalValue = {
      userLoginId: loginId,
      submittedBy: "RECRUITER",
      jobId: value.jobId !== '' ? value.jobId : "" ,
      action: "draft",
      jobMetadata: {
          postPosition:  value.data.postPosition,
          title:  value.data.title,
          resourceCount: value.data.resources ? value.data.resources : 0,
          jobRole: value.data.jobRole,
          jobType: value.data.jobType ? value.data.jobType : "",
          locationPreference: value.locationPreference,
          experienceRange : value.experienceRange ? value.experienceRange : {"min" : 0 , "max": 12},
          priority: value.data.priority ? value.data.priority.id : 2,
          coreSkills: value.data.coreSkills,
          otherSkills: value.data.otherSkills ? value.data.otherSkills : [],
          supportingDocument: value.supportingDocument !== ' '? value.supportingDocument : "", 
          contractDuration: value.data.contractDuration ? value.data.contractDuration : "",
          billingType: value.data.billingType ? value.data.billingType : "",
          currencyType: value.data.currencyType ? value.data.currencyType : "",
          minimumBudget: value.data.minimumBudget ? parseInt(value.data.minimumBudget) : undefined,
          maximumBudget: value.data.maximumBudget ? parseInt(value.data.maximumBudget) : undefined,
          jobDescription: value.data.jobDescription ?  value.data.jobDescription : "",
          contractStartDate: value.data.startDate ? value.data.startDate : 0,
          closedCount: counts.closedCount,
          lossCount: counts.lossCount
      },
    }
    const companyDetails = value.data.companyDetails ? value.data.companyDetails : ' '
    submitValues(finalValue, companyDetails, toggleButton)
  }
  
  const displayNotification = (action: string) => {
    if (action === 'draft') {
     setMessage('Position saved successfully')
    }
    else {
      setMessage('Position published successfully')
    }
    setNotification(true)
    setTimeout(() => {
      navigate('/positions')
      setNotification(false)
     }, 3000)  
  }

  const onClose = () => {
    setNotification(false)
   }


  return (
    <section className="dashboardWrapper">
      {notification && <NotificationAlert onClose={onClose } closable={true} >
          {message}
          </NotificationAlert> }
      <SideMenu menu={menu}/>
      <div className="dashboardContent">
        <DashboardHeader  
            // title="Positions / Create New Position"
            searchChange={undefined}
            title={BreadcrumsValues}
        />
        <CreatePosition save={save} publish={publish} postPositions={postPosition} skillsList={skillList} jobRolesList={jobRoleList} />
      </div>
    </section>
  )
}

export default CreatePositions